import http from './_http';
import { logWebHrError } from '@/core/logger/log-wrapper';

export default async function getDocsignatureFileFromDms({
  tenantId,
  employeeId,
  documentId,
}) {
  try {
    const { data } = await http.get(
      `/tenants/${tenantId}/employees/${employeeId}/signature-documents/${documentId}/signed-file`
    );

    return data;
  } catch (e) {
    logWebHrError({
      message: 'Docsignature API Error',
      source: 'get-docsignature-file',
      metadata: {
        tenantId,
        employeeId,
        documentId,
      },
      error: e,
    });
    throw e;
  }
}
